import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { Button, CloseBtn, Modal } from '@devesharp/react/web';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Style from './EstablishmentDetailPage.style';
import { LoadingPage } from '~/components';
import { CNPJAndCPFMask, formatDate, formatPrice } from '~/services';
import { useEstablishmentDetailPage } from '~/pages/EstablishmentDetail/EstablishmentDetailPage.controller';

export const EstablishmentDetailPage: React.FunctionComponent<any> = () => {
   const ctrl = useEstablishmentDetailPage();

   if (!ctrl.resource) {
      return (
         <Style>
            <LoadingPage />
         </Style>
      );
   }

   const resource = ctrl.resource;

   return (
      <Style>
         <div className="title-page">
            <div className="container">
               <div className="p-3">
                  <div className="row align-items-center">
                     <div className="col">
                        <h3 className="m-0 mb-1">{resource.name}</h3>
                        <small className="text-muted">Visualização do estabelecimento</small>
                     </div>
                     <div className="col-auto">
                        <Button variant="light" onClick={ctrl.backToListing}>
                           <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                        </Button>
                        &nbsp;
                        <Button variant="secondary" onClick={ctrl.openEditCompany}>
                           <FontAwesomeIcon icon={faEdit} /> Editar dados
                        </Button>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         {ctrl.starting && <LoadingPage />}

         <Container>
            <div className="row">
               <div className="col-md-4">
                  <Card className="mb-4">
                     <div className="p-4">
                        <h5>Resumo do estabelecimento</h5>
                        <p />

                        <p>
                           Nome
                           <br />
                           <b>{resource.name}</b>
                        </p>

                        <p>
                           Tipo
                           <br />
                           <b>{resource.type_name}</b>
                        </p>

                        <p>
                           CPF/CNPJ
                           <br />
                           <b>{resource.document ? CNPJAndCPFMask(resource.document) : '—'}</b>
                        </p>

                        <p>
                           E-mail
                           <br />
                           <b>{resource.email ?? '—'}</b>
                        </p>

                        <p>
                           Telefone
                           <br />
                           <b>{resource.phone ?? '—'}</b>
                        </p>

                        {resource.fantasy_name ? (
                           <p>
                              Nome fantasia
                              <br />
                              <b>{resource.fantasy_name}</b>
                           </p>
                        ) : null}

                        {resource.revenue ? (
                           <p>
                              Faturamento
                              <br />
                              <b>{formatPrice(Number(resource.revenue) * 100)}</b>
                           </p>
                        ) : null}

                        {resource.address_summary ? (
                           <p>
                              Endereço
                              <br />
                              <b>{resource.address_summary}</b>
                           </p>
                        ) : null}

                        <p>
                           Status
                           <br />
                           <b>{resource.enabled ? 'Ativo' : 'Inativo'}</b>
                           {resource.blocked ? ' · Bloqueado' : ''}
                        </p>

                        <p>
                           Criado em
                           <br />
                           <b>{formatDate(resource.created_at)}</b>
                        </p>
                     </div>
                  </Card>
               </div>

               <div className="col-md-8">
                  <div className="row">
                     <div className="col-md-6 mb-4">
                        <Card className="integration-card">
                           <Card.Body className="card-body">
                              <h5>Zoop</h5>
                              <p className="text-muted">Integração de pagamentos via Zoop</p>

                              <p>
                                 Status
                                 <br />
                                 {resource.has_zoop_seller ? (
                                    <span className={`status-badge ${resource.zoop_status ?? 'active'}`}>
                                       {resource.zoop_status_name ?? 'Cadastrado'}
                                    </span>
                                 ) : (
                                    <span className="status-badge pending">Pendente</span>
                                 )}
                              </p>

                              {resource.zoop_hash ? (
                                 <p>
                                    ID Zoop
                                    <br />
                                    <b>{resource.zoop_hash}</b>
                                 </p>
                              ) : null}

                              <div className="card-actions">
                                 <Button
                                    variant={resource.has_zoop_seller ? 'secondary' : 'primary'}
                                    onClick={ctrl.openZoop}
                                 >
                                    {resource.has_zoop_seller ? 'Gerenciar Zoop' : 'Cadastrar na Zoop'}
                                 </Button>
                              </div>
                           </Card.Body>
                        </Card>
                     </div>

                     <div className="col-md-6 mb-4">
                        <Card className="integration-card">
                           <Card.Body className="card-body">
                              <h5>Idez</h5>
                              <p className="text-muted">Conta digital Idez</p>

                              <p>
                                 Status
                                 <br />
                                 {resource.has_idez ? (
                                    <span className={`status-badge ${resource.idez_status ?? 'active'}`}>
                                       {resource.idez_status_name ?? 'Cadastrado'}
                                    </span>
                                 ) : (
                                    <span className="status-badge pending">Não configurado</span>
                                 )}
                              </p>

                              <p className="coming-soon">
                                 {resource.has_idez
                                    ? resource.idez_status === 'active'
                                       ? 'Conta digital ativa.'
                                       : 'Conclua a validação de identidade (biometria) para ativar a conta.'
                                    : 'Cadastre a conta digital Idez usando os dados deste estabelecimento.'}
                              </p>

                              {resource.has_idez &&
                              resource.idez_status !== 'active' &&
                              (resource.idez_biometrics ?? []).length > 0 ? (
                                 <div className="mb-3">
                                    {(resource.idez_biometrics ?? []).map((entity: any) => (
                                       <div key={entity.entity_id} className="mb-2">
                                          {entity.can_validate && entity.biometrics_url ? (
                                             <Button variant="primary" onClick={() => ctrl.validateKyc(entity)}>
                                                Validar KYC
                                                {entity.name ? ` — ${entity.name}` : ''}
                                             </Button>
                                          ) : null}
                                          {entity.needs_resend ? (
                                             <>
                                                &nbsp;
                                                <Button
                                                   variant="secondary"
                                                   disabled={ctrl.resendingEntity === entity.entity_id}
                                                   onClick={() => ctrl.resendKyc(entity)}
                                                >
                                                   {ctrl.resendingEntity === entity.entity_id
                                                      ? 'Renovando...'
                                                      : 'Renovar validação'}
                                                </Button>
                                             </>
                                          ) : null}
                                       </div>
                                    ))}
                                 </div>
                              ) : null}

                              <div className="card-actions">
                                 {!resource.has_idez && (
                                    <Button variant="secondary" onClick={ctrl.openAssociateIdezModal}>
                                       Associar por ID
                                    </Button>
                                 )}
                                 <Button
                                    variant={resource.has_idez ? 'secondary' : 'primary'}
                                    onClick={ctrl.openIdez}
                                 >
                                    {resource.has_idez ? 'Gerenciar Idez' : 'Cadastrar na Idez'}
                                 </Button>
                              </div>
                           </Card.Body>
                        </Card>
                     </div>
                  </div>
               </div>
            </div>
         </Container>

         <Modal show={ctrl.showAssociateIdezModal} onHide={ctrl.closeAssociateIdezModal}>
            <div className="foreground" onClick={ctrl.closeAssociateIdezModal} />

            <Modal.Body className="p-4 text-left w-100">
               {ctrl.associatingIdez && <LoadingPage />}
               <div className="close">
                  <CloseBtn onClick={ctrl.closeAssociateIdezModal} />
               </div>
               <div className="text-center">
                  <h4>Associar conta Idez por ID</h4>
               </div>
               <p className="text-muted text-center mt-3 mb-4">
                  Informe o ID da conta na Idez (UUID). A conta será buscada na API e vinculada a este
                  estabelecimento.
               </p>
               <div className="form-group">
                  <label htmlFor="associate-idez-id">ID da conta Idez</label>
                  <input
                     id="associate-idez-id"
                     type="text"
                     className="form-control"
                     placeholder="00000000-0000-0000-0000-000000000000"
                     value={ctrl.associateIdezId}
                     onChange={(event) => ctrl.setAssociateIdezId(event.target.value)}
                     disabled={ctrl.associatingIdez}
                  />
               </div>
               <div className="d-flex justify-content-center gap-2 mt-4">
                  <Button variant="secondary" onClick={ctrl.closeAssociateIdezModal} disabled={ctrl.associatingIdez}>
                     Cancelar
                  </Button>
                  <Button variant="primary" onClick={ctrl.submitAssociateIdez} disabled={ctrl.associatingIdez}>
                     Associar
                  </Button>
               </div>
            </Modal.Body>
         </Modal>
      </Style>
   );
};
